import React from "react";
import Layout from "../components/Layout";
import ProjectBoard from "../components/project/ProjectBoard";

function Project() {
  return (
    <Layout>
      <ProjectBoard />
    </Layout>
  );
}

export default Project;
